import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, HashRouter, Switch, Route } from 'react-router-dom';
import Util from './Util.js';
import Main from './Main.js';

import Promise from 'promise-polyfill';
if (!window.Promise) {
  window.Promise = Promise;
}

if (!Object.assign) {
  Object.assign = require('object-assign');
}

const content = document.getElementById('content');

var content_path = window.content_path;
const url = location.protocol + '//' + location.hostname + (location.port ? (":" + location.port) : "") + content_path + "api/examples/";

let lang = Util.GetCurrentCultureName()

let langFile = content_path + "config/i18n." + lang + ".json";
Util.LoadJSONFile(langFile, initHandler, pageInitExceptionHandler);

function initHandler(i18n) {
  return i18n ? pageInit(i18n) : pageInitExceptionHandler(null);
}

function pageInit(i18n) {
var routePath = content_path + ":demoid";
 var index = window.location.href.indexOf('#');
 if(index != -1){
	 window.location.href = window.location.href.replace('/#', '');
 }else{
  return ReactDOM.render((
    <BrowserRouter>
      <Switch>
        <Route exact path={content_path} render={props => <Main i18n={i18n} lang={lang} serverUrl={url} {...props} />} />
		    <Route exact path={routePath} render={props => <Main i18n={i18n} lang={lang} serverUrl={url} {...props} />} />
      </Switch>
    </BrowserRouter>
  ), content);
 }
}

function pageInitExceptionHandler(error) {
  lang = "en-US";
  return Util.LoadJSONFile(content_path + "config/i18n." + lang + ".json", pageInit);
}

